export const REGEX_PASSWORD=/^(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~])[\w!@#$%^&*()_+{}[\]:;<>,.?~]{8,}$/
export const REGEX_COLOR_HEX=/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/